module.exports = "https://d2e8d75hhtblx4.cloudfront.net/_next/static/public/static/images/favicon/apple-touch-icon-120x12010b201b8550ea3c1ccea2c2d8186999f.png";